export default "__VITE_ASSET__CeZkTJm4__"